var d3 = $.extend(require("d3-selection"), {});

var createId = () => (Math.random() * 1e16).toFixed(0);

var centerTextInCircle = function (textLines, circleRadius) {
    var line = d3.select(this);

    var textHeight = 0;
    textLines.each(function () {
        var line = d3.select(this);
        textHeight += line.node().getBBox().height;
    });

    var circleHeight = 2 * circleRadius;
    var heightOffset = (circleHeight - textHeight) / 2

    textLines.each(function () {
        var line = d3.select(this);
        line.attr("transform", "translate(0," + heightOffset + ")")
    });
}

var calcPathLength = function (paper, path) {
    var temp = paper
        .append("path")
        .attr("class", "temp")
        .attr("d", path);

    var length = paper.select(".temp").node().getTotalLength();
    temp.remove();

    return length;
};

var calcTextLength = function (paper, text, textAttrs) {
    var temp = paper
        .append("text")
        .text(text);

    Object.keys(textAttrs)
        .forEach(key => temp.attr(key, textAttrs[key]));

    var width = temp.node().getComputedTextLength();
    temp.remove();

    return width;
};

var getTextPart = function (paper, text, maxLength, textAttrs) {
    var words = text.split(" ");

    if (words.length === 1) {
        return text;
    }

    var lineLength = 0;
    var line = "";
    var result = "";
    var n = 0;

    while (n < words.length) {
        result = line;
        line = line + words[n] + " ";
        lineLength = calcTextLength(paper, line, textAttrs);
        if (lineLength > maxLength) {
            return result ? result : words[0];
        }
        n++;
    }

    return text;
};

var transformArcText = function (d, paper, radius, textFn, textAttrs, lineHeight) {
    var text = textFn(d);

    var transformedData = [];

    while (text) {
        var arc = d3.arc()
            .outerRadius(radius)
            .innerRadius(radius)(d);
        var path = d3.toSingleDirectionArc(arc)

        var arcLength = calcPathLength(paper, path);
        var textPart = getTextPart(paper, text, arcLength, textAttrs).trim();

        transformedData.push({
            id: createId(),
            path: path,
            text: textPart,
            attrs: textAttrs,
            source: d
        });

        text = text.replace(textPart, "").trim();
        radius = radius - (lineHeight || textAttrs["font-size"]);
    }

    return transformedData;
}

var transformLineText = function (d, paper, startX, startY, endX, endY, textFn, textAttrs, lineHeight) {
    var text = textFn(d);

    var transformedData = [];

    while (text) {
        var path = d3.line()([[startX, startY], [endX, endY]]);

        var lineLength = calcPathLength(paper, path);
        var textPart = getTextPart(paper, text, lineLength, textAttrs).trim();

        transformedData.push({
            id: createId(),
            path: path,
            text: textPart,
            attrs: textAttrs,
            source: d
        });

        text = text.replace(textPart, "").trim();
        startY += lineHeight || textAttrs["font-size"];
        endY = startY;
    }

    return transformedData;
}

var drawTextByPath = function(parent, data, cssClass, textAttrs) {
    var prefix = createId();

    var groups = parent
        .selectAll(cssClass)
        .data((d, i) => data[i])
        .enter().append("g")
        .attr("class", cssClass);

    var paths = groups.append("path")
        .attr("id", (d, i) => `${prefix}_${d.id}_${i}`)
        .attr("class", `${cssClass}__path`)
        .attr("d", d => d.path)
        .attr("fill", "none");

    var textLines = groups.append("text")
        .attr("class",`${cssClass}__line`)
        .attr("text-anchor", "middle");

    textLines
        .append("textPath")
        .attr("xlink:href", (d, i) => `#${prefix}_${d.id}_${i}`)
        .attr("startOffset", "50%")
        .text(d => d.text);
    Object.keys(textAttrs)
        .forEach(key => textLines.attr(key, textAttrs[key]));

    return textLines;
}

var toSingleDirectionArc = function(arcPath) {
    //NOTE: D3 renders arc as circle even innerRadius == 0;
    var parts = arcPath.split(/[A-Z]/)
    return "M" + parts[1] + "A" + parts[2];
}

module.exports = {
    centerTextInCircle,
    calcPathLength,
    transformArcText,
    transformLineText,
    drawTextByPath,
    toSingleDirectionArc
}
